import { render, staticRenderFns } from "./application_beststudent.vue?vue&type=template&id=0c2e78da&scoped=true"
import script from "./application_beststudent.vue?vue&type=script&lang=js"
export * from "./application_beststudent.vue?vue&type=script&lang=js"
import style0 from "./application_beststudent.vue?vue&type=style&index=0&id=0c2e78da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e78da",
  null
  
)

export default component.exports